import React from 'react'

import NewAgencyProducer from './NewAgencyProducer'
import BackButton from '../UI/BackButton'
import PageTitle from '../UI/PageTitle'


const NewAgencyProducerPage = () => (
  <section>
    <header>
      <PageTitle>New external project manager</PageTitle>
    </header>
    <NewAgencyProducer showSuccessDialog={true} />
    <br/>
    <BackButton/>
  </section>
)

export default NewAgencyProducerPage



// WEBPACK FOOTER //
// ./src/components/AgencyProducers/NewAgencyProducerPage.jsx